<nav class="navbar navbar-expand-md bg-dark navbar-dark fixed-top">
    <div class="container-fluid">
        <!-- Brand -->
        <a class="navbar-brand" routerLink="/">USC Films</a>

        <!-- Toggler/collapsibe Button -->
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#collapsibleNavbar" (click)="isCollapsed = !isCollapsed" >
            <span class="navbar-toggler-icon"></span>
        </button>
        <!-- Navbar links -->
        <div class="collapse navbar-collapse" id="collapsibleNavbar" [ngbCollapse]="isCollapsed">
            <ul class="navbar-nav mr-auto">
                <li class="nav-item">
                    <a class="nav-link" routerLink="/">Home</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" routerLink="/mylist">My List</a>
                </li>
            </ul>
            <div class="form-inline mr-4">
                <ng-template #rt let-r="result" let-t="term">
                    <img [src]="r.backdrop_path" class="mr-4" style="width: 100px">
                    <ngb-highlight [result]="r.name" [term]="t"></ngb-highlight>
                </ng-template>
                
                <input id="typeahead-http" type="text" class="form-control" 
                    [class.is-invalid]="searchFailed" 
                    [(ngModel)]="model" 
                    (ngModelChange)="modelChanges()"
                    [ngbTypeahead]="search" 
                    placeholder="Search" 
                    [resultTemplate]="rt"
                    [inputFormatter]="formatter"
                    [editable]='false'/>
                <!-- <small *ngIf="searching" class="form-text text-muted">searching...</small>
                <div class="invalid-feedback" *ngIf="searchFailed">Sorry, suggestions could not be loaded.</div> -->
            </div>
        </div>
    </div>
</nav>